<template>
  <div>
    <!-- <h2 class="dashboard-heading">Post New Opportunity</h2>
    <hr> -->
    <form class="profile-form">
      <div class="mb-2" :class="{ invalid: $v.title.$error }">
        <label>Title*</label>
        <input type="text" class="form-control" v-model="title">
        <small v-if="$v.title.$error">Job title is required.</small>
      </div>

      <div class="row">
        <div class="col-lg-9">
          <label>Description</label>
          <div class="editor">
            <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
            <editor-menu-bar :editor="descriptionEditor" v-slot="{ commands, isActive }" class="mb-1">
              <div class="menubar">
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                  <strong>B</strong>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                  <i>Italics</i>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                  <u>U</u>
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                  Image
                </button> -->
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                  Image
                </button> -->
                <!-- https://github.com/scrumpy/tiptap/issues/89 -->
                <!-- https://codesandbox.io/s/j3p0z44155 -->
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                  Image
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                  H1
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                  H2
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                  H3
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                  List
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                  1. 2. 3...
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                  ""
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                  ---
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                  Undo
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                  Redo
                </button> -->
              </div>
            </editor-menu-bar>
            <editor-content class="editor__content" :editor="descriptionEditor" />
          </div>
        </div>
        <div class="col-lg-3">
          <label>Key Skills</label>
          <!-- <div class="form-check" v-for="(skill, index) in skillsOptions" :key="'SelectSkills'+index">
            <input class="form-check-input" type="checkbox" :value="skill" v-model="skills">
            <label class="form-check-label">
              {{ skill }}
            </label>
          </div> -->
          <multiselect v-model="skills" :options="skillsOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Select Skills"></multiselect>
          <label>Topic Areas</label>
          <multiselect v-model="focusAreas" :options="focusAreaOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Select Topic Areas"></multiselect>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-lg-3">
          <label>Job Type*</label>
          <select class="form-control" v-model="jobType">
            <option v-for="(jobType, index) in jobTypeOptions" :key="'SelectJobType'+index">{{ jobType }}</option>
          </select>
        </div>
        <div class="col-lg-3">
          <label>Compensation Type</label>
          <select class="form-control" v-model="compensationType">
            <option v-for="(compensationType, index) in compensationTypeOptions" :key="'SelectCompType'+index">{{ compensationType }}</option>
          </select>
          <label>Compensation Range</label>
          <input type="text" class="form-control" v-model="compensation">
          <!-- <multiselect v-model="compensation" :options="salaryRangeOptions" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Select Range"></multiselect> -->
        </div>
        <div class="col-lg-6">
          <label>Application Deadline</label>
          <datepicker class="form-control" placeholder="" v-model="applicationDeadline" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          <label>Application Link</label>
          <input type="text" class="form-control" v-model="applicationLink">
        </div>
      </div>
      <hr>
      <div class="row pb-3">
        <div class="col-lg-6">
          <label>Address Line 1</label>
          <input type="text" class="form-control" placeholder="" v-model="address1">
          <label>Address Line 2</label>
          <input type="text" class="form-control" placeholder="" v-model="address2">
          <label>Postal/Zip Code</label>
          <input type="text" class="form-control" placeholder="" v-model="postalCode">
        </div>
        <div class="col-lg-6">
          <label>City</label>
          <input type="text" class="form-control" placeholder="" v-model="city">
          <label>Province/State</label>
          <input type="text" class="form-control" placeholder="" v-model="provinceState">
          <label>Country</label>
          <!-- <input type="text" class="form-control" placeholder="" v-model="country"> -->
          <select class="form-control" v-model="country">
            <option v-for="(country, index) in countries" :key="'countrySelection'+index">{{ country }}</option>
          </select>
        </div>
      </div>

      <!-- <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="save()">Post</button> -->
      <!-- {{ user }} -->
      <button v-if="!jobID" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="post('live')">Post</button>
      <button v-if="jobID" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="update()">Save Changes</button>
      <button v-if="jobID && this.jobToEdit.status === 'draft'" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="update('live')">Post Job Live</button>
      <button v-if="!jobID" class="mylisting-button dark-button mt-3" style="display: block;" @click.prevent="post('draft')">Save as Draft</button>
      <!-- {{ userID }} -->
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
  // Import the editor
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  // import Icon from 'Components/Icon'
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
  } from 'tiptap-extensions'

  export default {
    // props: ['userID'],
    props: ['userID', 'jobID'],
    components: {
      EditorContent,
      EditorMenuBar,
      Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
    },
    data() {
      return {
        user: {},

        title: '',
        description: '',
        descriptionEditor: null,
        status: '',
        skills: [],
        skillsOptions: [],
        jobType: '',
        jobTypeOptions: [],
        compensation: '',
        compensationType: '',
        compensationTypeOptions: [],
        focusAreas: [],
        focusAreaOptions: [],
        applicationDeadline: null,
        applicationLink: '',

        city: '',
        provinceState: '',
        country: '',
        countries: [],
        address1: '',
        address2: '',
        postalCode: '',

        // jobID: null,
        jobToEdit: {},
      }
    },
    validations: {
      title: {
        required,
      }
    },
    created() {
      this.getUser()

      this.skillsOptions = this.$store.getters.skills
      this.jobTypeOptions = this.$store.getters.jobTypes
      this.compensationTypeOptions = this.$store.getters.compensationTypes
      this.countries = this.$store.getters.countries
      this.focusAreaOptions = this.$store.getters.focusAreas
      this.salaryRangeOptions = this.$store.getters.salaryRanges

      // this is for a unique route for editing a job /edit-job/id
      if (this.$route.params.id) {
        this.jobID = this.$route.params.id
      }

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      this.descriptionEditor = new Editor({
        // content: this.description,
        content: '\
<h4>Summary</h4><p></p><hr>\
<h4>Roles and Responsibilities</h4><p></p><hr>\
<h4>Required Qualifications</h4><p></p><hr>\
<h4>Preferred Qualifications</h4><p></p><hr>\
<h4>Additional Information</h4><p></p>',
        autoFocus: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
        ],
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          // this.html = getHTML()
          this.description = getHTML()
        },
      })
    },
    beforeDestroy() {
      this.descriptionEditor.destroy()
    },
    methods: {
      getUser() {
        axios.get('/api/people/?id='.concat(this.userID))
          .then(res => {
            // console.log(res)
            this.user = res.data[0]

            this.address1 = this.user.address1
            this.address2 = this.user.address2
            this.postalCode = this.user.postal_code
            this.city = this.user.city
            this.provinceState = this.user.provincestate
            this.country = this.user.country

            // If jobID is not null, that means we are editing an existing job
            if (this.jobID) {
              console.log('Editing Job')
              console.log(this.jobID)
              axios.get('/api/jobs/?id='.concat(this.jobID.toString()))
                .then(res => {
                  console.log(res.data[0])
                  this.jobToEdit = res.data[0]

                  this.title = this.jobToEdit.title
                  this.status = this.jobToEdit.status
                  this.descriptionEditor.setContent(this.jobToEdit.description)
                  this.description = this.jobToEdit.description
                  this.skills = this.jobToEdit.skills
                  this.focusAreas = this.jobToEdit.skills2
                  this.jobType = this.jobToEdit.job_type
                  this.compensationType = this.jobToEdit.compensation_type
                  this.compensation = this.jobToEdit.compensation
                  this.applicationDeadline = this.jobToEdit.application_deadline
                  this.applicationLink = this.jobToEdit.link

                  this.address1 = this.jobToEdit.address1
                  this.address2 = this.jobToEdit.address2
                  this.postalCode = this.jobToEdit.postal_code
                  this.city = this.jobToEdit.city
                  this.provinceState = this.jobToEdit.provincestate
                  this.country = this.jobToEdit.country
                })
                .catch(error => console.log(error))
            }
            else {
              // If we are posting a new job, want to automatically set the application deadline to 6 weeks in the future
              let numWeeks = 6
              this.applicationDeadline = new Date()
              this.applicationDeadline = this.applicationDeadline.setDate(this.applicationDeadline.getDate() + numWeeks * 7); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
              // The above produces a date in the format 1588691516867, but that can't be written to the database, need a date like Tue May 05 2020 11:11:56 GMT-0400 (Eastern Daylight Time)
              this.applicationDeadline = new Date(this.applicationDeadline)
            }
          })
          .catch(error => console.log(error))
      },
      post(val) {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },2500)

        // Need to strip the compensation down to only numbers?
        // Will the application deadline work directly?

        console.log(this.userID)
        console.log(this.user.employer_name)
        console.log(this.title)
        console.log(this.status)
        console.log(this.description)
        console.log(this.skills)
        console.log(this.jobType)
        console.log(this.compensationType)
        console.log(this.compensation)
        console.log(this.applicationDeadline)
        console.log(this.applicationLink)
        console.log(this.address1)
        console.log(this.address2)
        console.log(this.postalCode)
        console.log(this.city)
        console.log(this.provinceState)
        console.log(this.country)

        axios.post('/api/jobs/', {
          poster: this.userID,
          poster_name: this.user.employer_name,
          status: val,
          title: this.title,
          description: this.description,
          skills: this.skills,
          skills2: this.focusAreas,
          job_type: this.jobType,
          compensation_type: this.compensationType,
          compensation: this.compensation,
          salaryRangeOptions: [],
          application_deadline: this.applicationDeadline,
          link: this.applicationLink,

          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,

          agency: this.$store.getters.agencyID,
          agency_owner: this.$store.getters.agencyName,
        })
        .then(res => {
          console.log(res)

          // broadcast to the parent compoenent that a job has been posted
          // this.$emit('jobPosted', true) // Lecture 112
          this.$emit('jobPosted') // Lecture 112

          if (this.status === 'live') {
            this.sendEmail()
          }
        })
        .catch(error => console.log(error))
      },
      update(val) {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },2500)

        // Changes a 'draft' post to a live one by updating the status
        if (val === 'live') {
          this.status = val
          this.sendEmail()
        }

        // Need to strip the compensation down to only numbers?
        // Will the application deadline work directly?

        axios.patch('/api/jobs/'.concat(this.jobID.toString()).concat('/'), {
          // poster: this.userID,
          // poster_name: this.user.employer_name,
          status: this.status,
          title: this.title,
          description: this.description,
          skills: this.skills,
          skills2: this.focusAreas,
          job_type: this.jobType,
          compensation_type: this.compensationType,
          compensation: this.compensation,
          application_deadline: this.applicationDeadline,
          link: this.applicationLink,

          address1: this.address1,
          address2: this.address2,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.provinceState,
          country: this.country,
        })
          .then(res => {
            console.log(res)

            // broadcast to the parent compoenent that a job has been posted
            // this.$emit('jobPosted', true) // Lecture 112
            this.$emit('jobUpdated') // Lecture 112
          })
          .catch(error => console.log(error))
      },
      sendEmail() {
        // Email to inform Hayley and I of new job posts
        // this.$store.dispatch('sendEmail',
        //   {
        //     subject: 'New Job Post!',
        //     message: 'New job posted with the title: '+this.title+'\nOrganization: '+this.user.employer_name,
        //     // from: 'info@thrivehire.co',
        //     from: 'info@thrivehire.co',
        //     // email: 'aakash@enginehire.ca',
        //     email: 'info@thrivehire.org',
        //     reply: 'info@thrivehire.co',
        //     // userID: this.aakashid,
        //     userID: this.$store.getters.agencyID
        //   }
        // )
        this.$store.dispatch('sendEmail',
          {
            subject: 'New Job Post!',
            message: 'New job posted with the title: '+this.title+'\nOrganization: '+this.user.employer_name,
            // from: 'info@thrivehire.co',
            from: 'info@thrivehire.co',
            email: 'aakash@enginehire.ca',
            reply: 'info@thrivehire.co',
            // userID: this.aakashid,
            userID: this.$store.getters.agencyID
          }
        )
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/employers/jobs/JobForm.vue